import { DOCUMENT_CATEGORIES } from "./desktopDocumentCategories.constants"
import { isRecord } from "@/utils/typeGuards.utils"

export function getDocumentType(
    data: Record<string, unknown> | undefined
): string | null {
    if (!data) return null
    if (typeof data.documentType === "string") return data.documentType
    if (!isRecord(data.document)) return null
    const doc = data.document
    if (typeof doc.documentType === "string") return doc.documentType
    return typeof doc.type === "string" ? doc.type : null
}

export function getDocumentIconSrc(
    data: Record<string, unknown> | undefined
): string | null {
    const type = getDocumentType(data)
    if (!type) return null
    return DOCUMENT_CATEGORIES.find(cat => cat.type === type)?.iconSrc ?? null
}
